module.exports = __webpack_public_path__ + "static/student_feedback-573f13e53f3800d15da318eea3a000d0.png";